var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 192,
    height: 192,
    viewBox: "0 0 196 196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_220",
    "data-name": "Group 176427"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_220",
    "data-name": "Ellipse 220",
    cx: 95,
    cy: 95,
    r: 95,
    transform: "translate(2 2)",
    stroke: "gray",
    strokeWidth: 1,
    strokeDasharray: 12,
    fill: "#00000000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_220",
    "data-name": "Ellipse 220",
    cx: 87,
    cy: 87,
    transform: "translate(9 10)",
    r: 87,
    fill: "#eff5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3592",
    "data-name": "Path 3592",
    d: "M243.977,130.733c-.34,3.4-.553,6.8-1.046,10.163a85.879,85.879,0,0,1-23.755,48.311,5.648,5.648,0,0,1-.538.438c-9.239-27.846-28.308-43.571-57.783-47.171,11.274-1.652,20.112-6.9,26.137-16.337a34.44,34.44,0,0,0,3.781-30.5c-5.342-16.31-21.193-26.079-38.637-24.03-15.915,1.869-29.222,15.881-30.679,31.815-1.75,19.069,12.045,37.012,31.358,39.094-29.092,3.5-48.15,19.224-57.507,47.212-.948-1-1.954-1.991-2.888-3.058a85.993,85.993,0,0,1-22.154-54.248,16.081,16.081,0,0,0-.258-1.7v-4.155a15.43,15.43,0,0,0,.258-1.7A84.222,84.222,0,0,1,86.98,77.371c14.533-19.551,33.959-31.141,58.1-34.71,3.258-.483,6.554-.68,9.837-1.019H159.1a12.285,12.285,0,0,0,1.529.252A83.865,83.865,0,0,1,204.87,56.24q32.28,21.822,38.118,60.483c.489,3.249.68,6.544,1.019,9.816v4.176Z",
    transform: "translate(-61 -31.8)",
    fill: "#64bcfc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.74b5cdc235c0767bfd253dfc66a35cad.svg";
export { ForwardRef as ReactComponent };